import React from  "react";
import "./portfolio.css";
import dogimage from "../assets/dog-logo.jpg";
import weatherimage from "../assets/snowflake_weather_app.png";
import cartimage from "../assets/shoppingcart.jpg";
import frontendmentor from "../assets/frontendmentor.jfif";

import Data from "../data/portfolioData";


function Portfolio(){
  return(
    <div id="Portfolio" className="Portfolio">

        <div className="portfolio-heading" data-aos="fade-right" data-aos-duration="600" data-aos-delay="100">
            <h1>MY <span className="portfolio-heading-span">PORTFOLIO</span></h1>
        </div>


        <div className="projects">

            {Data.map((x)=>(
                      <div className="project-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="300">
                      <div className="image-project-div">
                          <img className="project-image" src={x.source}></img>
                      </div>
                      <h2 className="project-title">{x.title}</h2>
                      <h3 className="project-tec">{x.tech_used}</h3>
                      <p className="project-desc">
                            {x.description}
                      </p>
                      <div className="portfolio-a-div">
                        <a href={x.link} target="_blank" className="live-link">Live Link</a>
                      </div>
                </div>
            ))}

            


            {/* <div className="project-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="300">
                  <div className="image-project-div">
                      <img className="project-image" src={weatherimage}></img>
                  </div>
                  <h2 className="project-title">React-powered weather companion.</h2>
                  <h3 className="project-tec">ReactJS - CSS3</h3>
                  <p className="project-desc">
                        Explore real-time forecasts, interactive visuals, and
                        global coverage. Access hourly details, and enjoy
                        responsive design.
                  </p>
                  <div className="portfolio-a-div">
                    <a href="https://myweatherappaks.netlify.app/" target="_blank" className="live-link">Live Link</a>
                  </div>
            </div> */}

            {/* <div className="project-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="500">
                  <div className="image-project-div">
                      <img className="project-image" src={cartimage}></img>
                  </div>
                  <h2 className="project-title">Redux Shopping Cart</h2>
                  <h3 className="project-tec">ReactJS - Redux</h3>
                  <p className="project-desc">By leveraging the power of React
                    Redux, I've created an efficient and organized shopping
                    experience that allows users to effortlessly add, remove,
                    and update items in their cart.
                  </p>
                  <div className="portfolio-a-div">
                    <a href="https://myshoppingcartaks.netlify.app/" target="_blank" className="live-link">Live Link</a>
                  </div>
            </div> */}

            {/* <div className="project-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="300">
                  <div className="image-project-div">
                      <img className="project-image" src={dogimage}></img>
                  </div>
                  <h2 className="project-title">Doge-Date</h2>
                  <h3 className="project-tec">Bootstrap - CSS3</h3>
                  <p className="project-desc">front-end page for a Dating
                  for dog website. The main framework used for building
                  the Doge-date website is bootstrap4 and its components
                  like Carousel, Card, Button, Navbar.
                  </p>
                  <div className="portfolio-a-div">
                    <a href="https://akshatsc.github.io/Doge-Date/" target="_blank" className="live-link">Live Link</a>
                  </div>
            </div>
            <div className="project-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="300">
                  <div className="image-project-div">
                      <img className="project-image" src={frontendmentor}></img>
                  </div>
                  <h2 className="project-title">FrontEnd Mentor</h2>
                  <h3 className="project-tec">ReactJS - CSS</h3>
                  <p className="project-desc">This contains link to My profile in Frontend mentor platform
                  . It contains collection of various Challenges I have completed on the platform. It contains link to 
                  Code base as well as Task deployed link.
                  </p>
                  <div className="portfolio-a-div">
                    <a href="https://www.frontendmentor.io/profile/AkshatSC" target="_blank" className="live-link">Profile Link</a>
                  </div>
            </div> */}

        </div>


    </div>
  );
}

export default Portfolio;
